export default "__VITE_ASSET__DNCdW8RA__"